import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OrderStatus } from "../constants";
import { premiumPaths } from "../navigation";
import IssueConfirmationDialog from "./orders/IssueConfirmationDialog";

/** Wystawienie jest dostępne dopiero po przygotowaniu aktualnego podglądu. */
export default function IssueActions({ order, ready, busy, approve }) {
  const [confirmation, setConfirmation] = useState(null);
  const canIssue =
    ready &&
    !busy &&
    order.status === OrderStatus.REVIEW &&
    order.previewRevision === order.revision;
  useEffect(() => {
    setConfirmation((current) =>
      !canIssue ||
      current?.id !== order.id ||
      current?.revision !== order.revision
        ? null
        : current,
    );
  }, [order.id, order.revision, canIssue]);
  return (
    <section className="card premium-panel premium-actions">
      <h2>Wystaw świadectwo</h2>
      <p className="text-muted">
        Podgląd aktualnych danych jest gotowy. Potwierdź wystawienie świadectwa,
        aby otrzymać dokument z numerem i podpisem.
      </p>
      <dl className="premium-issue-summary">
        <dt>Eksporter</dt>
        <dd style={{ whiteSpace: "pre-line" }}>{order.config.exporter}</dd>
        <dt>Faktura</dt>
        <dd>{order.draft.invoiceNumbers || "Nie podano"}</dd>
        <dt>Odbiorca</dt>
        <dd>{order.draft.recipient.name || "Nie podano"}</dd>
      </dl>
      <div className="premium-form-actions">
        {!busy && (
          <Link
            className="btn btn-outline-primary"
            to={premiumPaths.preview(order.id)}
          >
            Wróć do podglądu świadectwa
          </Link>
        )}
        <button
          type="button"
          className="btn btn-primary"
          disabled={!canIssue}
          onClick={() =>
            setConfirmation({ id: order.id, revision: order.revision })
          }
        >
          Zatwierdź i wystaw świadectwo
        </button>
      </div>
      {confirmation?.id === order.id &&
        confirmation?.revision === order.revision &&
        canIssue && (
          <IssueConfirmationDialog
            order={order}
            onCancel={() => setConfirmation(null)}
            onConfirm={() => {
              setConfirmation(null);
              approve();
            }}
          />
        )}
    </section>
  );
}
